import BaseModule from './BaseModule.js';

class OtcOrderTransfer extends BaseModule {
  async paginate({ page, per_page, term, status, customer_id }) {
    return await this.get(`back-office/otc/transfer/orders`, {
      params: { page, per_page, term, status, customer_id },
    });
  }

  async fetch(id) {
    return await this.get(`back-office/otc/transfer/orders/${id}`);
  }

  async retrySendToken(id) {
    return await this.get(`back-office/otc/transfer/orders/${id}/retry`);
  }
}

export default OtcOrderTransfer;
